<template />

<script>
import util from '@/utils/util'
export default {
  created() {
    const page = util.getUrlKey('page')
    const number = util.getUrlKey('number')
    // app = url.replace(url.slice(0, 5) === "https" ? "https" : "http", "app");
    window.location.href = `app://com.haier.rrs.driver/data?page=${page}&number=${number}`
  }
}
</script>

<style lang="scss" scoped>
</style>
